import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { darken } from 'polished'

export const NFTMarketPlaceMenuLink = styled(NavLink)`
	display: flex;
	text-decoration: none;
	color: ${({ theme }) => theme.text1};

	:hover,
	:focus {
		color: ${({ theme }) => darken(0.1, theme.text1)};
		transform: scale(1.02);
	}
`

export const NavBarContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	max-width: 960px;
	margin: 0 1rem;

`

export const NavBarItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem;
	min-width: 100px;
`
